import { connect } from 'react-redux';
import RoomsWrapper from "../components/general/RoomsWrapper";
import { graphql } from 'react-apollo';
import { getRooms } from "../graphql/query/rooms";
import { REMOVE_ROOM } from "../store/actions/room";

const mapStateToProps = state => {
    return {
        
    };
};

const mapDispatchToProps = dispatch => {
    return {
        REMOVE_ROOM: body => dispatch(REMOVE_ROOM(body)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(graphql(getRooms)(RoomsWrapper));


// WEBPACK FOOTER //
// ./src/containers/Rooms.js